import React from 'react';
import { useNavigate } from 'react-router-dom'; // Pour la navigation
import './Terms.css';

const Terms = () => {
  const navigate = useNavigate(); // Hook pour gérer la navigation

  const handleBack = () => {
    navigate(-1); // Retourne à la page précédente
  };

  return (
    <div className="terms-container">
      <button className="back-button" onClick={handleBack}>
        ← Retour
      </button>
      <h1 className="terms-title">Conditions d'utilisation</h1>
      <div className="terms-content">
        <section className="terms-section">
          <h2>1. Introduction</h2>
          <p>
            Bienvenue sur DWAG, une plateforme de quiz éducative. En utilisant notre application, vous acceptez les présentes conditions d'utilisation. Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser notre service.
          </p>
        </section>

        <section className="terms-section">
          <h2>2. Utilisation de l'application</h2>
          <p>
            DWAG est destiné à un usage personnel et non commercial. Vous vous engagez à ne pas utiliser l'application à des fins illégales ou non autorisées. Vous êtes responsable de toutes les activités effectuées sous votre compte.
          </p>
        </section>

        <section className="terms-section">
          <h2>3. Compte utilisateur</h2>
          <p>
            Pour accéder à certaines fonctionnalités, vous devez créer un compte. Vous êtes responsable de la confidentialité de vos identifiants. DWAG se réserve le droit de suspendre ou de supprimer votre compte en cas de violation des présentes conditions.
          </p>
        </section>

        <section className="terms-section">
          <h2>4. Propriété intellectuelle</h2>
          <p>
            Tout le contenu de l'application, y compris les quiz, textes, images et logos, est la propriété de DWAG ou de ses partenaires. Vous n'êtes pas autorisé à reproduire, distribuer ou modifier ce contenu sans autorisation préalable.
          </p>
        </section>

        <section className="terms-section">
          <h2>5. Limitation de responsabilité</h2>
          <p>
            DWAG fournit l'application "telle quelle". Nous ne garantissons pas que l'application sera exempte d'erreurs ou d'interruptions. DWAG ne sera pas responsable des dommages directs ou indirects résultant de l'utilisation de l'application.
          </p>
        </section>

        <section className="terms-section">
          <h2>6. Modifications des conditions</h2>
          <p>
            DWAG se réserve le droit de modifier ces conditions d'utilisation à tout moment. Les modifications seront publiées sur cette page, et votre utilisation continue de l'application constituera une acceptation des nouvelles conditions.
          </p>
        </section>

        <section className="terms-section">
          <h2>7. Contact</h2>
          <p>
            Si vous avez des questions concernant ces conditions d'utilisation, vous pouvez nous contacter à l'adresse suivante : <a href="mailto:dwag.contact@gmail.com">dwag.contact@gmail.com</a>.
          </p>
        </section>
      </div>
    </div>
  );
};

export default Terms;